import { length, has } from 'ramda';

import { searchInContactPoint } from '../api/data-nova';

export const DATA_NOVA_MAP_SEARCH_REQUEST = 'DATA_NOVA_MAP_SEARCH_REQUEST';
export const DATA_NOVA_MAP_SEARCH_SUCCESS = 'DATA_NOVA_MAP_SEARCH_SUCCESS';
export const DATA_NOVA_MAP_SEARCH_FAILURE = 'DATA_NOVA_MAP_SEARCH_FAILURE';

export const loadMapSearchRequest = () => ({
  type: DATA_NOVA_MAP_SEARCH_REQUEST,
});

export const loadMapSearchSuccess = ({ results, ...context }) => ({
  type: DATA_NOVA_MAP_SEARCH_SUCCESS,
  payload: results,
  context,
});

export const loadMapSearchFailure = (error) => ({
  type: DATA_NOVA_MAP_SEARCH_FAILURE,
  payload: error,
});

export const normalizeError = (error) => {
  if (has('error', error)) {
    return error.error;
  }
  return error;
};

/**
 * @param {String} query
 * @param {?Integer} page
 */
export const loadMapSearchData = (query, page) => async (dispatch) => {
  if (length(query) >= 2) {
    try {
      dispatch(loadMapSearchRequest());

      const response = await searchInContactPoint(query, page);

      dispatch(loadMapSearchSuccess(response));
    } catch (error) {
      dispatch(loadMapSearchFailure(normalizeError(error)));
    }
  }
};
